module.exports = __webpack_public_path__ + "assets/img/icon4.043eab51.svg";